import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Company } from 'src/app/core/companies.service';
import { DialogService } from 'src/app/core/dialog.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ARCHIVED_COMPANIES_TABLE_COLUMNS, COMPANIES_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { ArchivedCompaniesNoteDialogComponent } from '../archived-companies-note-dialog/archived-companies-note-dialog.component';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-archived-companies-data-table',
  templateUrl: './archived-companies-data-table.component.html',
  styleUrls: ['./archived-companies-data-table.component.scss'],
})
export class ArchivedCompaniesDataTableComponent {
  @Input() companies: Company[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = ARCHIVED_COMPANIES_TABLE_COLUMNS;

  constructor(
    private utils_service: UtilsService,
    private decimal_pipe: DecimalPipe,
    private dialog_service: DialogService,
    private navigation_service: NavigationService,
  ) {}

  onNoteClick(company: Company): void {
    this.dialog_service.openDialog(ArchivedCompaniesNoteDialogComponent, { company });
  }

  getRevenuesRange(company: Company): string {
    if (company) {
      const min_revenue: string | null = this.formatNumber(company.min_revenue);
      const max_revenue: string | null = this.formatNumber(company.max_revenue);
      return company ? `${min_revenue}€ - ${max_revenue}€` : '-';
    }
    return '-';
  }

  getCompanyStatusBackgroundClass(company?: Company): { [key: string]: boolean } {
    if (!company) return {};
    return this.utils_service.getCompanyStatusBackgroundClass(company);
  }

  getCompanyStatusLabel(company: Company): string {
    if (!company?.status) return '';
    return this.utils_service.getCompanyStatusLabel(company.status);
  }

  formatNumber(digits: number): string | null {
    return this.decimal_pipe.transform(digits, '0.2-2', 'it-IT');
  }

  onDetailsClick(company: Company): void {
    this.navigation_service.toCompanyDetails(company.company_id as string);
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }
}
